import React, { Component } from 'react'
import {Link} from "react-router-dom";

export default class Footer extends Component {
  render() {
    return (
            <section id="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <div className="footer-topic">
                                <ul>
                                    <li>© 1998-{(new Date()).getFullYear()} <a href="https://www.rehabmart.com" rel="noopener noreferrer" target="_blank">Rehabmart.com, LLC </a>|</li>
                                    <li><Link to="/source">Sources</Link> | </li>
                                    {/* eslint-disable-next-line */}
                                    <li><a data-featherlight={"<p class='d-lightbox'>Dizziness is a complex symptom that is difficult to diagnose, even for professionals. Because of this, our quiz is best used as a teaching tool to help you better understand dizziness. It is not a substitute for consultation with a medical professional. If you, your patient, or your loved one is experiencing dizziness that could be caused by a stroke, toxicity, or infectious disease, it's important that you contact a healthcare professional right away</p>"}>Disclaimer</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
  }
}
